<template>
    <div class="container">
            <div class="seacher">
                <!-- 日期选择器 -->
                <el-form :model="queryParams" ref="queryForm" label-width="100px" size="mini">
                    <el-form-item label="开始时间" prop="startTime">
                        <el-date-picker size="small"  clearable
                            v-model="queryParams.beginTime" type="date" value-format="yyyy-MM-dd"
                            placeholder="选择开始时间">
                            <!-- placeholder="选择开始时间" :picker-options="startNoTime"> -->
                        </el-date-picker>
                    </el-form-item>
                    <el-form-item size="small" label="结束时间" prop="endTime">
                        <el-date-picker  clearable
                            v-model="queryParams.endTime" type="date" value-format="yyyy-MM-dd"
                            placeholder="选择结束时间" >
                            <!-- placeholder="选择结束时间" :picker-options="endNoTime"> -->
                        </el-date-picker>
                    </el-form-item>
                </el-form>
                <el-form :inline="true" class="demo-form-inline"   label-width="80px" size="mini">
                    <el-form-item  label="发票号" prop="radio">
                        <el-input size="small" clearable v-model.trim="queryParams.voucherNo" placeholder="请输入发票号"
                            style="width: 100%;"></el-input>
                    </el-form-item>
                    <el-form-item label="备注">
                        <el-input size="small" clearable v-model="queryParams.note" placeholder="请输入备注"
                            style="width: 100%;"></el-input>
                    </el-form-item>
                    <el-form-item label="往来单位">
                        <el-select size="small" filterable clearable v-model="queryParams.company"
                            placeholder="请选择往来单位">
                            <el-option v-for="item in customOption" :key="item.id" :label="item.name"
                                :value="item.name">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="申请单号">
                       <el-input size="small" clearable v-model.trim="queryParams.billNo" placeholder="请输入发票号"
                            style="width: 100%;"></el-input>
                    </el-form-item>
                    <el-form-item label="申请人">
                        <el-select size="small"  filterable clearable v-model="queryParams.applyMan"
                            placeholder="请选择申请人">
                            <el-option v-for="item in applyManList" :key="item.id" :label="item.userName"
                                :value="item.userName">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="审核状态">
                        <el-radio-group v-model="queryParams.checkStatus" @input="approveState">
                            <el-radio label="0" >新建</el-radio>
                            <el-radio label="1">审核中</el-radio>
                            <el-radio label="2">审核完成</el-radio>
                            <el-radio label="3">审核驳回</el-radio>
                            <el-radio label="9">待我审核</el-radio>
                        </el-radio-group>
                        <!-- <el-radio v-model="queryParams.checkStatus" label="0">未审核</el-radio>
                        <el-radio v-model="queryParams.checkStatus" label="1">已审核</el-radio> -->
                    </el-form-item>
                </el-form>
                <div style="min-width: 130px;">
                    <el-button type="primary" @click="submit" size="small">查询</el-button>
                    <el-button type="success" @click="add"  size="small">添加</el-button>
                    <!-- <el-button type="warning" @click="collectRegistTo">收款登记</el-button> -->
                </div>
            </div>
            <div class="main_height">
                <el-table :data="list" :cell-style="rowStyle" id="tableId" ref="tableId" height="100%"
                    style=" margin-top: 0px;" :summary-method="getSummaries" :show-summary="list.length === 0 ? false: true" border
                     >
                    <!-- highlight-current-row  @current-change="handleCurrentcol" -->
                    <el-table-column label="序号" type="index" width="50" align="center">
                    </el-table-column>
                    <af-table-column label="单据编号" align="center" >
                        <template slot-scope="scope">
                            <!-- <i class="iconfont icon-bianmubianma"></i> -->
                            <span @click="handleClick(scope.row.id)" :class="{ hoverStyle: true }"
                                style="cursor: pointer">{{ scope.row.billNo }}</span>
                        </template>
                    </af-table-column>
                    <af-table-column label="委托单位" align="center">
                        <template slot-scope="scope">
                            <span>{{ scope.row.company }}</span>
                        </template>
                    </af-table-column>
                    <af-table-column label="发票号" align="center">
                        <template slot-scope="scope">
                            <span>{{ scope.row.voucherNo }}</span>
                        </template>
                    </af-table-column>
                    <af-table-column label="金额" align="center" prop="amount">
                        <template slot-scope="scope">
                            <span v-format="'#,##0.00'">{{ scope.row.amount }}</span>
                        </template>
                    </af-table-column>
                    <af-table-column label="币制" align="center">
                        <template slot-scope="scope">
                            <span>{{ scope.row.currency }}</span>
                        </template>
                    </af-table-column>
                    <af-table-column label="审核状态" align="center">
                        <template slot-scope="scope">
                            <span><el-link type="primary" @click="getCommentText(scope.row)">{{ getCheckStatusText(scope.row.checkStatus) }}</el-link></span>
                            <!-- <span>{{ getCheckStatusText(scope.row.checkStatus) }}</span> -->
                        </template>
                    </af-table-column>
                    <af-table-column label="发票状态" align="center">
                        <template slot-scope="scope">
                            <span v-if="scope.row.financeStatus === '已开票'"><el-tag  type="success">{{ scope.row.financeStatus }}</el-tag></span>
                            <span v-else>{{ scope.row.financeStatus }}</span>
                        </template>
                    </af-table-column>
                    <af-table-column label="创建人" align="center">
                        <template slot-scope="scope">
                            <span>{{ scope.row.createMan }}</span>
                        </template>
                    </af-table-column>
                    <af-table-column label="创建时间" align="center" width="140">
                        <template slot-scope="scope">
                            <span>{{ scope.row.createTime }}</span>
                        </template>
                    </af-table-column>
                    <af-table-column label="备注" align="center">
                        <template slot-scope="scope">
                            <span>{{ scope.row.note }}</span>
                        </template>
                    </af-table-column>
                    <af-table-column label="操作" align="center"  width="250" fixed="right" >
                        <template slot-scope="scope">
                            <!-- <el-button round size="small" icon="el-icon-edit" type="warning"
                                @click="amendRow(scope.row)">修改</el-button> -->
                                <el-button plain size="mini" icon="el-icon-s-check" type="primary" v-if="queryParams.checkStatus == '0' || queryParams.checkStatus == '3'"
                                    @click="approvalShow(scope.row)">发起审批</el-button>
                                <el-button plain size="mini" icon="el-icon-circle-check" type="success" v-if="queryParams.checkStatus == '9'"
                                    @click="approvalPass(scope.row)">审批</el-button>
                                <el-button plain size="mini" icon="el-icon-delete" type="danger" v-if="queryParams.checkStatus == '0'"
                                    @click="deleteRow(scope.row)">删除</el-button>
                                <el-button plain size="mini" icon="el-icon-position" type="primary" v-if="queryParams.checkStatus == '2'"
                                    @click="issueInvoice(scope.row)">发票登记</el-button>
                                <!-- <el-button plain size="mini" type="warning" icon="el-icon-notebook-2" v-if="queryParams.checkStatus == '2'" @click="collectRegistTo(scope.row)">收款登记</el-button> -->
                                <el-button plain size="mini" icon="el-icon-refresh-left" type="primary" v-if="queryParams.checkStatus == '1'"
                                @click="withdraw(scope.row)">撤回</el-button>
                        </template>
                    </af-table-column>
                </el-table>
        </div>
        <div style="background-color: white;">
                <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                    :current-page="currentPage" :page-sizes="[10, 50, 100,1000]" :page-size="10" style="padding: 10px;"
                    layout="sizes, prev, pager, next" :total="total">
                </el-pagination>
            </div>
        <addFundIn ref="addFundIn" :busId="id"></addFundIn>
        <!-- <collectRegist ref="collectRegist" :colId="colId"></collectRegist> -->
        <!-- 发起审批弹出框 -->
        <el-dialog title="发起审批" :visible.sync="approvalDialog" width="40%" :before-close="cancelApproval">
            <el-form :model="approvalFrom" label-width="80px" :rules="approvalRules" ref="approvalFrom" >
                <el-form-item label="财务单据">
                    <el-input v-model="approvalFrom.voucherName" :disabled="true"></el-input>
                </el-form-item>
                <el-form-item label="业务主管" prop="manager">
                    <div>{{ approvalFrom.manager }}</div>
                    <!-- <el-select style="width: 100%;" v-model="approvalFrom.manager" placeholder="请选择客户经理">
                        <template v-for="(item,index) in staffOption">
                            <el-option :label="item.userName" :value="item.userName"></el-option>
                        </template>
                    </el-select> -->
                </el-form-item>
                <el-form-item label="流程名称" prop="flowKey">
                    <el-select style="width: 100%;" v-model="approvalFrom.flowKey" placeholder="请选择审批流程" @change="changeFlowKey">
                        <template v-for="(item,index) in flowableList">
                            <el-option :label="item.name" :value="item.keyName"></el-option>
                        </template>
                    </el-select>
                </el-form-item>
                <el-form-item label="">
                    {{ approvalFrom.description }}
                </el-form-item>

            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="cancelApproval">取 消</el-button>
                <el-button type="primary" @click="submitApproval">提交审批</el-button>
            </span>
        </el-dialog>
        <!-- 审批意见弹出框 -->
        <el-dialog title="审批意见" :visible.sync="opinionDialog" width="40%" @before-close="opinionDialog = false; opinionText = '';">
            <span v-for="item in opinionText">
                <div style="margin-bottom: 10px;margin-right: 10px;">{{item}}</div>
            </span>
            <!-- 步骤条  -->
             <!-- <el-steps v-if="stepBar.processInstanceId" :active="stepBar.completedNodes.length + 1" finish-status="success">
                <el-step title="发起审批" description=""> </el-step>
                <el-step v-for="item,index in stepBar.allNodes" :title="item.nodeName" :description="item.assigneeId">
                    <template slot="description" >
                        <span>
                            {{item.assigneeId}}<br/>
                        </span>
                        <span v-if="index+1 <= stepBar.completedNodes.length">
                            开始审批：{{item.startTime}}<br/>
                            结束审批：{{item.endTime}}<br/>
                            审批耗时：{{item.duration}}
                        </span>
                    </template>
                </el-step>
                <el-step title="结束审批" description=""> </el-step>
            </el-steps> -->
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="opinionDialog = false; opinionText = ''">确 定</el-button>
            </span>
        </el-dialog>
        <!-- 审批意见填写 -->
        <el-dialog title="审批意见" :visible.sync="opinionFillDialog" width="40%" :before-close="cencelOpinion">
            <el-input v-model="opinionFill.comment" placeholder="请输入审批意见"></el-input>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="agree">同意</el-button>
                <el-button type="primary" @click="reject">驳回</el-button>
                <el-button type="primary" @click="cencelOpinion">取消</el-button>
            </span>
        </el-dialog>
        <!-- 发票开出弹窗，上传附件+填写发票号 -->
        <el-dialog title="发票登记" :visible.sync="invoiceDialog" width="40%" :before-close="cancelInvoice">
            <el-form :model="invoiceFrom" label-width="80px" :rules="invoiceRules" ref="invoiceFrom" >
                <el-form-item label="发票号" prop="fpNum">
                    <el-input v-model="invoiceFrom.fpNum" clearable ></el-input>
                    <!-- <el-input v-model="invoiceFrom.fpNum" clearable onkeyup="value=value.replace(/[^\d]/g,'')" ></el-input> -->
                </el-form-item>
                <el-form-item label="上传附件" prop="file">
                    <el-upload class="upload-demo" :action="saveOneAttachmentURL" :file-list="invoiceFrom.file" multiple :auto-upload="false"
                    :on-change="handleChange" :on-remove="handleRemove" >
                    <el-button size="small" type="primary">选择文件</el-button>
                    </el-upload>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="cancelInvoice">取 消</el-button>
                <el-button type="primary" @click="submitInvoice()">提 交</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import addFundIn from "@/view/addFundIn.vue";
// import collectRegist from "@/view/collectRegist.vue";
import req from '@/utils/index.js'
import url from '@/config/url1.js'
import url1 from '@/config/url2.js'
export default {
    name: 'invoiceRequest',
    components: { addFundIn, },
    data() {
        return {
            colId: '',//单据id
            id: '',//传值id
            applyManList:[], // 人员列表
            customOption: [],//委托单位数据
            classOption: [],//货物分类数据
            queryParams: {
                beginTime: '', //创建时间(开始)
                endTime: '', //创建时间(结束)
                company: '',
                voucherNo: '',
                checkStatus: '0',
                note: '',//备注
                flag: 'FP',
                billNo:'',
            },
            list: [],
            currentPage: 1, // 当前页数
            pageSize: 10, // 每页显示的数据量
            total: 0, // 总数据量
            condition: '',
            approvalDialog:false, // 审批弹窗
            approvalFrom:{
                voucherId:'',
                voucherName:'',
                flowKey:'',
                description:'',
                manager:'',
            }, // 审批信息
            flowableList:[], // 审批流程列表
            // staffOption:[], // 客户经理列表
            opinionDialog:false, // 审批意见弹窗
            opinionText:[], // 审批意见文字
            opinionFillDialog:false, // 填写审批意见弹窗
            opinionFill:{ // 填写审批意见
                instanceId:'',
                voucherId:'',
                comment:'',
            }, 
            // 发票开出弹窗
            invoiceDialog:false,
            // 发票开出form
            invoiceFrom:{
                fpNum:'',
                file:[],
                voucherId:'',
            },
            // 审批规则
            approvalRules:{
                flowKey:[
                    { required: true, message: '请选择流程名称', trigger: 'change' },
                ],
                manager:[
                    { required: true, message: '请选择客户经理', trigger: 'change' },
                ],
            },
            // 发票开出规则
            invoiceRules:{
                fpNum: [
                    { required: true, message: '请填写发票号', trigger: 'change' }
                ]
            },
            saveOneAttachmentURL:url1.saveOneAttachment, // 上传文件url
            // 开始时间限制范围
            startNoTime: {
                disabledDate(date) {
                    // 可选当天以及当天之前的日期
                    return date.getTime() > Date.now()
                }
            },
            // 结束时间限制范围
            endNoTime: {
                disabledDate(date) {
                    // 可选当天以及当天之前的日期
                    return date.getTime() > Date.now()
                }
            },
            valto: [],

        }
    },
    watch: {
        "queryParams.beginTime": {
            handler(val) {
                if (val) {
                    this.endNoTime = {
                        disabledDate(time) {
                            const time1 = new Date(val).getTime() - 8.64e7;
                            return time.getTime() < time1 || time.getTime() > Date.now()
                        }
                    }
                } else {
                    // 当清空时，进行一些默认的设置或恢复初始的禁用规则
                    this.endNoTime = {
                        disabledDate(time) {
                            return time.getTime() > Date.now()
                        }
                    }
                }
            }
        },
        "queryParams.endTime": {
            handler(val) {
                if (val) {
                    this.startNoTime = {
                        disabledDate(time) {
                            const time1 = new Date(val).getTime()
                            return time.getTime() > time1 || time.getTime() > Date.now()
                        }
                    }
                } else {
                    this.startNoTime = {
                        disabledDate(time) {
                            return time.getTime() > Date.now()
                        }
                    }
                }
            }
        },
    },
    mounted() {
        this.getcustomList();
        this.getClassOption();
        this.submit();
        this.getApplyMan();
        this.getFlowableList();
        // this.getStaffList();
    },
    methods: {
        getApplyMan(){
            let URL = `${url.getOnDutyList}`;
            req.get(URL).then(res => {
                if (res.data.code === 200) {
                    this.applyManList = res.data.data
                }
            })
        },
        // 点击审核状态，直接调用接口
        approveState(data){
            // 待我审核
            if(data === '9'){
                let URL = `${url1.getMyTask}`;
                req.get(URL).then(res => {
                    if(res.data.code !== 200){
                        this.list = []
                        this.$message({
                            type: 'warning',
                            message: res.data.message
                        });
                    }else{
                        this.list = res.data.data.filter(function (item) {
                            return item.flag === 'FP';
                        });
                    }
                })
            }else{
                this.submit()
            }
            this.$nextTick(() => {
                this.$refs.tableId.doLayout();
            });
        },
        // 查询发起审批时的客户经理
        // getManagerByVoucherId(){
        //     let URL = `${url1.getManagerByVoucherId}/${this.approvalFrom.voucherId}`;
        //     req.get(URL).then(res => {
        //         if (res.data.code == 200) {
        //             this.approvalFrom.manager = res.data.data;
        //         } else {
        //             this.$message.error(res.data.message);
        //         }
        //     })
        // },
        // 发起审批流程
        approvalShow(data){
            if(localStorage.getItem('name') === data.createMan){
                this.approvalDialog = true
                this.approvalFrom.manager = localStorage.getItem('manager')
                this.approvalFrom.voucherId = data.id
                this.approvalFrom.voucherName = data.billNo
                // this.getManagerByVoucherId()                
            }else{
                this.$message.error({
                    message: '非本人创建不可发起审批'
                });
            }

        },
        // 显示审批意见
        getCommentText(data){
            this.opinionDialog = true
            if(data.comment === null){
                this.opinionText = ['无']
            }else{
                this.opinionText = data.comment.split(';')
            }
        },
        // 获取审批流程
        getFlowableList() {
            let URL = `${url1.getFlowableList}`;
            req.get(URL).then(res => {
                if (res.data.code == 200) {
                    this.flowableList = res.data.data;
                } else {
                    this.$message.error(res.data.message);
                }
            })
        },
        //获得客户经理数据
        // getStaffList() {
        //     let URL = `${url.getUserByRole}/客户经理`;
        //     req.get(URL).then(res => {
        //         if (res.data.code === 200) {
        //             this.staffOption = res.data.data;
        //         }
        //     })
        // },
        // 表单显示审批流程的备注
        changeFlowKey(data){
            const description = this.flowableList.filter(function(val) {
                return val.keyName === data;
            });
            this.approvalFrom.description = description[0].description
        },
        // 审批同意或驳回
        approvalPass(data){
            // 查询是否是本人待审
            let URL = `${url1.approvalJudgment}/${data.processInstanceId}/`;
            req.get(URL).then(res => {
                if (res.data.code === 200) {
                    this.opinionFillDialog = true
                    this.opinionFill.voucherId = data.id
                    this.opinionFill.instanceId = data.processInstanceId
                    this.opinionFill.comment = ''
                }
            })
        },
        // 取消审批
        cancelApproval(){
            this.approvalDialog = false
            this.approvalFrom = {
                voucherId:'',
                voucherName:'',
                flowKey:'',
                description:'',
                manager:'',
            }
            this.$refs.approvalFrom.resetFields();
        },
        // 提交审批
        submitApproval(){
            this.$refs.approvalFrom.validate((valid) => {
                if (valid) {
                    // 提交流程
                    let URL = `${url1.startProcess}/${this.approvalFrom.manager}/${this.approvalFrom.flowKey}/${this.approvalFrom.voucherId}`;
                    req.put(URL).then(res => {
                        if (res.data.code === 200) {
                            this.$message({
                                type: 'success',
                                message: '提交成功!'
                            });
                            this.approvalDialog = false
                            this.approvalFrom = {}
                            this.submit()
                        }
                    })
                } else {
                    return false;
                }
            });
        },
        // 同意审批
        agree(){
            let URL = `${url1.finishMyTask}/${this.opinionFill.instanceId}/${this.opinionFill.voucherId}?comment=${this.opinionFill.comment}`;
            req.post(URL).then(res => {
                if (res.data.code === 200) {
                    this.$message({
                        type: 'success',
                        message: res.data.data
                    });
                    this.opinionFillDialog = false
                    this.approveState('9');
                }
            })
        },
        // 驳回审批
        reject(){
            if(this.opinionFill.comment === '' || this.opinionFill.comment === ' '){
                this.$message.error('驳回请填写审批意见');
            }else{
                let URL = `${url1.rejected}/${this.opinionFill.instanceId}/${this.opinionFill.voucherId}?comment=${this.opinionFill.comment}`;
                req.post(URL).then(res => {
                    if (res.data.code === 200) {
                        this.$message({
                            type: 'success',
                            message: res.data.data
                        });
                        this.opinionFillDialog = false
                        this.approveState('9');
                    }
                })
            }
        },
        // 发票开出，上传附件+填写发票号
        issueInvoice(data){
            // 判断身份是财务
            if(localStorage.getItem('role') === '财务'){
                this.invoiceDialog = true
                this.invoiceFrom.voucherId = data.id
                this.invoiceFrom.fpNum = data.voucherNo
            }else{
                this.$message.error({
                    message: '非财务人员不可发票登记'
                });
            }
            
        },
        // 文件上传时勾子
        handleChange(file, fileList){
            this.invoiceFrom.file = fileList;
        },
        // 移除文件勾子
        handleRemove(file, fileList){
            this.invoiceFrom.file = fileList;
        },
        // 取消弹窗
        cancelInvoice(){
            this.invoiceFrom = {
                fpNum:'',
                file:[],
                voucherId:'',
            }
            this.$refs.invoiceFrom.resetFields();
            this.invoiceDialog = false
        },
        // 发票申请提交
        async submitInvoice(){
            let arr = [];
            let that = this;
            await this.$refs.invoiceFrom.validate((valid) => {
                if (valid) {
                    // 发票号提交
                    let URL = `${url1.insFPNum}/${this.invoiceFrom.voucherId}/${this.invoiceFrom.fpNum}`;
                     req.put(URL).then(res => {
                        if (res.data.code === 200) {
                            this.$message({
                                type: 'success',
                                message: '发票号提交成功!'
                            });
                            // 上传附件，循环单个上传
                            if(this.invoiceFrom.file.length > 0){
                                let fileUrl = `${url1.saveOneAttachment}`
                                const arr = this.invoiceFrom.file.map(item => {
                                    const formData = new FormData();
                                    formData.append('file', item.raw)
                                    formData.append('voucherId', this.invoiceFrom.voucherId)
                                    formData.append('annexType', '财务附件')
                                    req.post(fileUrl,formData).then(res => {
                                        if (res.data.code === 200) {
                                            
                                        }else{
                                            that.$message({
                                                type: 'warning',
                                                message: res.data.message
                                            });
                                            return false;
                                        }
                                    })
                                });
                                Promise.all(arr).then(results => {
                                    this.invoiceDialog = false
                                    this.invoiceFrom = {}
                                    this.submit()
                                })
                                .catch(error => {
                                    console.error(error);
                                });
                            }else{
                                this.cancelInvoice()
                                this.submit()
                            }
                        }else{
                            this.$message({
                                type: 'warning',
                                message: res.data.message
                            });
                            return false;
                        }
                    })
                } else {
                    return false;
                }
            });
        },
        //双击弹出收款登记
        // handleClickm(val) {
        //     this.colId = val.id;
        //     const URL = `${url1.whetherOrNotMakeSkRecord}`;
        //     req.get(URL).then(res => {
        //         if (res.data.code === 200) {
        //             this.$message.success(res.data.message);

        //             if (this.colId) {
        //                 this.$refs.collectRegist.dialogFormVisible = true;
        //                 this.$nextTick(() => {
        //                     this.$refs.collectRegist.getFundDetail(val);
        //                 });
        //             } else {
        //                 this.$message.warning('请选择要收款的单据');
        //             }
        //         } else {
        //             this.$message.error(res.data.message);
        //         }
        //     });

        // },
        // 单选行
        handleCurrentcol(val) {
            if(val !== null){
                this.colId = val.id
                this.valto = val;
            }
        },
        //收款登记
        // collectRegistTo(data) {
        //     if(localStorage.getItem('role') === '财务'){
        //         if(data.voucherNo !== ''){
        //             const URL = `${url1.whetherOrNotMakeSkRecord}`;
        //             req.get(URL).then(res => {
        //                 if (res.data.code === 200) {
        //                     this.$message.success(res.data.message);
        //                     if (this.colId) {
        //                         this.$refs.collectRegist.dialogFormVisible = true;
        //                         this.$nextTick(() => {
        //                             this.$refs.collectRegist.getFundDetail(this.valto);
        //                         });
        //                     } else {
        //                         this.$message.warning('请选择要收款的单据');
        //                     }
        //                 } else {
        //                     this.$message.error(res.data.message);
        //                 }
        //             });
        //         }else{
        //             this.$message.error({
        //                 message: '请填写发票号后再进行收款登记'
        //             });
        //         }
        //     }else{
        //         this.$message.error({
        //             message: '非财务人员不可收款登记'
        //         });
        //     }
        // },
        deleteRow(row) {
            const value = localStorage.getItem('name');
            if (row.createMan !== value) {
                this.$message({
                    type: 'error',
                    message: '非本人创建，无法删除!'
                });
            } else {
                this.$confirm('此操作将永久删除, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    let URL = `${url1.deleteById}/${row.id}`;
                    req.delete(URL).then(res => {
                        if (res.data.code == 200) {
                            this.$message({
                                type: 'success',
                                message: '删除成功!'
                            });
                            this.submit();
                        } else {
                            this.$message({
                                type: 'error',
                                message: res.data.message
                            })
                        }
                    })
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消删除'
                    });
                });
            }
        },
        //区别状态
        getCheckStatusText(status) {
            switch (status) {
                case 0:
                    return '新增';
                case 1:
                    return '审核中';
                case 2:
                    return '审核完成';
                case 3:
                    return '驳回';
                default:
                    return '未知状态';
            }
        },
        handleClick(row) {
            this.id = row;
            this.$refs.addFundIn.dialogFormVisible = true;
            this.$nextTick(() => {
                this.$refs.addFundIn.getFundDetail(row);
            });
            // this.$refs.addFund.getFundDetail();
        },
        rowStyle() {
            return "text-align:center";
        },
        search() {
            this.getData(1);

        },
        submit() {
            // 当审核状态为待我审核时，不操作；状态为其他时调用接口
            if( this.queryParams.checkStatus !== '9' ){
                this.getData(1);
            }else{
                this.approveState('9')
            }
        },
        // 页数发生改变时
        handleCurrentChange(val) {
            this.currentPage = val;
            this.getData(this.currentPage);
        },
        handleSizeChange(val) {
            this.pageSize = val
            this.getData(this.currentPage)

        },
        getData(page) {
            this.currentPage = page;
            let URL = `${url1.getMyVoucherList}/${this.currentPage}/${this.pageSize}`;
            req.post(URL, this.queryParams).then(res => {
                if (res.data.code === 200) {
                    this.total = res.data.data.total;
                    this.list = res.data.data.records;

                }
            })
        },
        // 撤回审批
        withdraw(data){
            this.$confirm('是否确定撤回该审批?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                let URL = `${url1.withdraw}/${data.processInstanceId}/${data.id}`;
                req.post(URL).then(res => {
                    if (res.data.code == 200) {
                        this.$message.success(res.data.data);
                        this.submit()
                    } else {
                        this.$message.error(res.data.message);
                    }
                })
            }).catch(() => {
                return        
            });
        },
        //添加
        add() {
            this.$refs.addFundIn.dialogFormVisible = true;
            this.$nextTick(() => {
                this.$refs.addFundIn.getFundDetail(0);
            });
        },
        // 获取货物分类数据
        getClassOption() {
            let value = '货物分类';
            let URL = `${url.getDicList}/?value=${value}`;
            req.post(URL).then(res => {
                if (res.data.code === 200) {
                    this.classOption = res.data.data.data;
                }
            })
        },
        //获取委托单位数据
        getcustomList() {
            let URL = `${url1.getList}/?name=`;
            req.get(URL).then(res => {
                if (res.data.code === 200) {
                    this.customOption = res.data.data;
                }
            })
        },
        // 审批意见窗口关闭
        cencelOpinion(){
            this.opinionFill = { 
                instanceId:'',
                voucherId:'',
                comment:'',
            },
            this.opinionFillDialog = false
        },
        // 表格合计
        getSummaries(param) {
            const { columns, data } = param;
            const sums = [];
            columns.forEach((column, index) => {
                if (index === 0) {
                    // 第一列显示"合计"文本
                    sums[index] = '合计';
                    return;
                }
                // 只计算金额列(prop为'amount')
                if (column.property === 'amount') {
                    const values = data.map(item => Number(item[column.property]));
                    // 排除非数值
                    const validValues = values.filter(value => !isNaN(value));
                    if (validValues.length > 0) {
                        sums[index] = validValues.reduce((prev, curr) => {
                            return prev + curr;
                        }, 0);
                            // 添加单位（可选）
                        sums[index] = Number(sums[index]).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,');
                        } else {
                            sums[index] = ' ';
                        }
                    } else {
                        // 其他列留空
                        sums[index] = '';
                    }
            });
            return sums;
        },

    },
}
</script>

<style lang="css" scoped>
.container{
    width: 100%;
    height: calc(100vh - 82px);
    display: flex;
    flex-direction: column;
    
}
.seacher{
    padding-top: 10px;
    display: flex;
    /* font-size: calc(15vw * 100 / 1920); */
}
.hoverStyle:hover {
    color: rebeccapurple;
    /* 设置悬停时的字体颜色 */
    text-decoration: underline;
    /* 添加下划线 */
}
.main_height{
    flex:1;
    /* font-size: calc(15vw * 100 / 1920); */
}
::v-deep .cell {
    /* white-space: nowrap; */
    /* overflow: auto; */
    display: inline-block;
}


.el-form-item {
    margin-bottom: 10px;
}
::v-deep .el-table__body tr.current-row>td {
    background-color: #2383e9 !important;
    color: #fff;
}
</style>